import React from "react";

import WorkoutAnalysisTableRow, {
  IRowData
} from "./WorkoutAnalysisTableRow/WorkoutAnalysisTableRow";
import useStyles from "./styles";

interface IProps {
  title: string;
  rows: IRowData[];
  className?: string;
}

const WorkoutAnalysisTable = (props: IProps) => {
  const { title, rows, className } = props;

  const classes = useStyles();

  const tableRows = rows.map((row, index) => (
    <WorkoutAnalysisTableRow key={index} data={row} />
  ));

  return (
    <div className={className}>
      <div className={classes.tableTitle}>{title}</div>
      {tableRows}
    </div>
  );
};

export default React.memo(WorkoutAnalysisTable);
